import { render, staticRenderFns } from "./LibBadge.vue?vue&type=template&id=42c2bd8c&scoped=true"
import script from "./LibBadge.vue?vue&type=script&lang=js"
export * from "./LibBadge.vue?vue&type=script&lang=js"
import style0 from "./LibBadge.vue?vue&type=style&index=0&id=42c2bd8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c2bd8c",
  null
  
)

export default component.exports